export const captureTokensInStringRegex = /(\$\d+)/g;
export const captureThemeColorRegex = /(color_\d+)/;

export const tokenizeByRegex = (
  expression: string,
  regexToTokenizeBy: RegExp,
) => {
  const tokenMap = new Map();

  let remainingExpression = expression;
  while (
    remainingExpression.length &&
    regexToTokenizeBy.test(remainingExpression)
  ) {
    remainingExpression = remainingExpression.replace(
      regexToTokenizeBy,
      (subString: string) => {
        const key = `$${tokenMap.size}`;
        tokenMap.set(key, subString);
        return key;
      },
    );
  }

  return { remainingExpression, tokenMap };
};
